(function () {
  const FINISH_PRODUCTS = {
    'overlock-ends': { handle: 'overlocked-runner-ends', label: 'Overlock Ends' },
    'mitre-ends': { handle: 'mitre-runner-ends', label: 'Mitre Ends' },
    'fringe-ends': { handle: 'fringe-runner-ends', label: 'Fringe Ends' }
  };

  function ensureHiddenInput(form) {
    let input = form.querySelector('input[name="properties[Finish]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Finish]';
      form.appendChild(input);
    }
    return input;
  }

  async function fetchProductCard(key, config) {
    try {
      const res = await fetch(`/products/${config.handle}.js`);
      const product = await res.json();
      return {
        key,
        label: config.label,
        price: product.price,
        image: product.featured_image || (product.images && product.images[0]) || null,
        variantId: product.variants[0].id
      };
    } catch (err) {
      console.error('Failed to load finish product', config.handle, err);
      return { key, label: config.label, price: null, image: null, variantId: null };
    }
  }

  function formatPrice(cents) {
    if (cents == null) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  async function addPaidFinishToCart(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
    if (!res.ok) {
      throw new Error('Cart add failed with status ' + res.status);
    }
    return res.json();
  }

  async function addPaidFinishInBackground(variantId, label) {
    if (!variantId) return;

    const maxAttempts = 3;
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        await addPaidFinishToCart(variantId);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        return; // success
      } catch (err) {
        console.error(`Failed to add finish (attempt ${attempt}/${maxAttempts})`, err);
        if (attempt < maxAttempts) {
          await new Promise((resolve) => setTimeout(resolve, 500 * attempt));
        }
      }
    }

    // All attempts failed - let the customer know so it doesn't slip through silently
    showFinishAddWarning(label);
  }

  function showFinishAddWarning(label) {
    const existing = document.getElementById('runner-finish-warning');
    if (existing) existing.remove();

    const banner = document.createElement('div');
    banner.id = 'runner-finish-warning';
    banner.className = 'runner-finish-warning';
    banner.innerHTML = `
      <span>We had trouble adding "${label}" to your cart. Please check your cart before checking out, and add it manually if it's missing.</span>
      <button type="button" aria-label="Dismiss">&times;</button>
    `;
    banner.querySelector('button').addEventListener('click', () => banner.remove());
    document.body.appendChild(banner);
  }

  async function openModal({ form, submitButton, hiddenInput, onResolved, rawEdgeImage }) {
    const existing = document.getElementById('runner-finish-popup');
    if (existing) existing.remove();

    const overlay = document.createElement('div');
    overlay.id = 'runner-finish-popup';
    overlay.className = 'runner-finish-popup-overlay';
    overlay.innerHTML = `
      <div class="runner-finish-popup" role="dialog" aria-modal="true" aria-labelledby="runner-finish-popup-title">
        <button type="button" class="runner-finish-popup__close" aria-label="Close">&times;</button>
        <h2 id="runner-finish-popup-title">Finish your runner's ends</h2>
        <p>Choose how you'd like the ends of your runner finished before adding it to your cart.</p>
        <div class="runner-finish-popup__grid" data-grid></div>
      </div>
    `;
    document.body.appendChild(overlay);

    const grid = overlay.querySelector('[data-grid]');
    grid.innerHTML = '<p class="runner-finish-popup__loading">Loading options...</p>';

    overlay.querySelector('.runner-finish-popup__close').addEventListener('click', () => overlay.remove());
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) overlay.remove();
    });

    const entries = Object.entries(FINISH_PRODUCTS);
    const cards = await Promise.all(entries.map(([key, config]) => fetchProductCard(key, config)));

    grid.innerHTML = '';

    cards.forEach((card) => {
      const el = document.createElement('button');
      el.type = 'button';
      el.className = 'runner-finish-card';
      el.innerHTML = `
        ${card.image ? `<img src="${card.image}" alt="${card.label}" loading="lazy">` : '<div class="runner-finish-card__placeholder"></div>'}
        <span class="runner-finish-card__label">${card.label}</span>
        ${card.price != null ? `<span class="runner-finish-card__price">${formatPrice(card.price)}</span>` : ''}
      `;
      el.addEventListener('click', async () => {
        el.disabled = true;
        el.classList.add('is-loading');
        hiddenInput.value = card.label;
        addPaidFinishInBackground(card.variantId, card.label); // fire-and-forget, don't block on this
        overlay.remove();
        onResolved();
      });
      grid.appendChild(el);
    });

    const rawEdgeEl = document.createElement('button');
    rawEdgeEl.type = 'button';
    rawEdgeEl.className = 'runner-finish-card runner-finish-card--raw-edge';
rawEdgeEl.innerHTML = `
      ${rawEdgeImage ? `<img src="${rawEdgeImage}" alt="Raw Edge" loading="lazy">` : '<div class="runner-finish-card__placeholder"></div>'}
      <span class="runner-finish-card__label">Raw Edge</span>
      <span class="runner-finish-card__price">No charge</span>
    `;
    rawEdgeEl.addEventListener('click', () => {
      hiddenInput.value = 'Raw Edge';
      overlay.remove();
      onResolved();
    });
    grid.appendChild(rawEdgeEl);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const marker = document.getElementById('runner-finish-required');
    if (!marker) return;

    const rawEdgeImage = marker.dataset.rawEdgeImage || '';

    let form = marker.dataset.formId ? document.getElementById(marker.dataset.formId) : null;
    if (!form) {
      const container = marker.closest('.product__info-container') || document;
      form = container.querySelector('form[data-type="add-to-cart-form"]');
    }
    if (!form) return;

    const submitButton = form.querySelector('button[name="add"]');
    if (!submitButton) return;

    const hiddenInput = ensureHiddenInput(form);
    let chosen = false;

    submitButton.addEventListener('click', function (event) {
      if (chosen) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      openModal({
        form,
        submitButton,
        hiddenInput,
        rawEdgeImage,
        onResolved: () => {
          chosen = true;
          submitButton.click();
        }
      });
    });
  });
})();